import { LatLngBounds } from 'leaflet'
import { useEffect } from 'react'
import { useMap } from 'react-leaflet'

export const FitToBounds = ({
  bounds,
  maxZoom = 20,
}: {
  bounds: LatLngBounds
  maxZoom?: number
}) => {
  const map = useMap()

  useEffect(() => {
    if (!map) return

    map.fitBounds(bounds, { maxZoom })
  }, [map, bounds])

  return null
}
